





import { Component, Vue } from "vue-property-decorator";
import { CalendarOptions, EventMountArg } from "@fullcalendar/core";
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import bsPlugin from "@fullcalendar/bootstrap";
import listPlugin from "@fullcalendar/list";
import interactionPlugin from "@fullcalendar/interaction";
import moment from "moment";
import { Tab } from "@/store/modules/types";
import { randomId } from "@/utils";
@Component({
  components: {
    FullCalendar,
  },
})
export default class TaskCalendar extends Vue {
  options: CalendarOptions = {
    plugins: [
      dayGridPlugin,
      timeGridPlugin,
      bsPlugin,
      listPlugin,
      interactionPlugin,
    ],
    events: this.eventSource,
    eventClick: this.eventClick,
    eventDidMount: this.eventDidMount,
    headerToolbar: {
      left: "dayGridMonth,timeGridWeek,timeGridDay,listWeek",
      center: "title",
      right: "today prevYear,prev,next,nextYear",
    },
    buttonText: {
      today: "Today",
      month: "Month",
      week: "Week",
      day: "Day",
      list: "List",
    },
    initialView: "dayGridMonth",
    themeSystem: "bootstrap",
  };
  eventSource(info: any, success: any) {
    const dueDateFrom = moment(info.start).format("YYYY-MM-DD");
    const dueDateTo = moment(info.end).format("YYYY-MM-DD");
    this.$store.commit("main/SET_LOADING", true);
    this.$store
      .dispatch("cases/getTaskCalendar", {
        dueDateFrom,
        dueDateTo,
      })
      .then((events) => {
        this.$store.commit("main/SET_LOADING", false);
        success(events);
      });
  }
  eventDidMount(info: EventMountArg) {
    const { el } = info;
    switch (info.view.type) {
      case "dayGridMonth":
        el.classList.add("mb-1");
        el.querySelector(".fc-event-title")!.innerHTML = info.event.title;
        el.querySelector(".fc-event-title")!.classList.add("text-wrap", "p-1");
        el.querySelector(".fc-event-time")!.classList.add("d-none");
        el.querySelector(".fc-daygrid-event-dot")!.classList.add("d-none");
        break;
      case "timeGridWeek":
        el.querySelector(".fc-event-title")!.innerHTML = info.event.title;
        el.querySelector(".fc-event-title")!.classList.add("text-wrap", "p-1");
        break;
      case "listWeek":
        el.querySelector(".fc-list-event-dot")!.classList.add("d-none");
        el.querySelector(".fc-list-event-time")!.classList.add("d-none");
        el.querySelector(".fc-list-event-title")!.innerHTML = info.event.title;
        el.querySelector(".fc-list-event-title")!.classList.add(
          "text-wrap",
          "p-1"
        );
        break;
    }
  }
  eventClick(info: any) {
    const { caseId } = info.event.extendedProps;
    this.editCase(caseId);
  }
  async editCase(caseId: string) {
    // GET CASE RECORD
    this.$store.commit("main/SET_LOADING", true);
    try {
      const data = await this.$store.dispatch("cases/getRecord", caseId);
      data.record.patientInfo = {
        demographic: null,
        contacts: [],
        providers: [],
        gaps: [],
      };
      data.record.medicationNotes = [];
      data.record.comments = [];
      // CREATE TAB
      const id = randomId(6);
      const tab: Tab = {
        id,
        name: `Case ${caseId}`,
        component: "CaseEditor",
        props: {
          tabId: id,
          caseRecord: data.record,
        },
        showRemove: true,
      };
      // ADD CASE TAB
      this.$store.commit("cases/ADD_NEW_TAB", tab);
      //
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
    //
  }
}
